import apiClient from './apiClient';

/**
 * @param {string} [status] - PENDING | APPROVED | REJECTED (omit for all)
 */
export async function listUsers(status) {
  const config = {};
  if (status) {
    config.params = { status };
  }
  const { data } = await apiClient.get('admin/users', config);
  return data;
}

export async function getUserDetail(id) {
  const { data } = await apiClient.get(`admin/users/${id}`);
  return data;
}

/**
 * @param {number|string} id
 * @param {'USER'|'ADMIN'} [role] - defaults to USER (standard accounts)
 */
export async function approveUser(id, role = 'USER') {
  const { data } = await apiClient.post(`admin/users/${id}/approve`, { role });
  return data;
}

export async function rejectUser(id) {
  const { data } = await apiClient.post(`admin/users/${id}/reject`);
  return data;
}
